export const useStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'calc(100% - 10px)',
        padding: "0px 15px 10px 15px",
        marginBottom: "10px"
    },
    cardContainer: {
        backgroundColor: "#FFFFFF",
        borderRadius: "20px",
        height: "100%",
        overflowY: "auto",
        padding: '20px 20px 0px 20px'

    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    },
    mainHeadingText: {
        fontSize: theme.typography.h4,
        fontWeight: 600
    },
    saveBtn: {
        height: '35px',
        borderRadius: '20px',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#0B51C5',
        color: "#FFFFFF"
    },
    btnText: {
        fontSize: theme.typography.h5,
        fontWeight: 600,
    },
    card: {
        height: '100%',
        cursor: 'pointer',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        backgroundColor: '#FFFFFF',
        color: theme.palette.text.primary,
    },
    cardBody: {
        backgroundColor: '#FFFFFF',
        color: theme.palette.text.primary,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    cardHeadingText: {
        fontSize: theme.typography.h6,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    noRecordsText: {
        fontSize: theme.typography.h6,
        fontWeight: 400
    }
})